import React from "react";

export default function SQL_UNION() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_UNION</h1>
      <p>This is the SQL_UNION component generated from the SQL JSON.</p>
    </div>
  );
}
